export default __webpack_public_path__ + "static/media/fridge2-beforeA-1440w.b0238331.avif";